import {toCamelCase} from 'case-converter'
import {
  assignPrices,
  checkPricesWarnings, fetchErrorsHandler, fetchStart, fetchSuccessful,
  fetchSynchronizer,
  filterByValues, getFetchDate,
  switchMbToGb
} from '~/helpers/prices/_utils/prices'
import {clonePrices} from '~/helpers/prices/msk/_clone-prices'
import * as kubernetes from '~/helpers/prices/msk/enum'

export const state = () => ({
  pricesMks: [],
  mksFetchDate: '',
  fetchingNow: false,
  fetchingResult: ''
})

export const mutations = {
  setMksPrices(state, value) {
    state.pricesMks = value
  },
  setMksFetchDate(state, value) {
    state.mksFetchDate = value
  },
  setFetchingState(state, value) {
    state.fetchingNow = value
  },
  setFetchingResult(state, value) {
    state.fetchingResult = value
  }
}

export const actions = {
  async fetchMksPrices({commit, state}, options) {
    if (state.fetchingNow) {
      return fetchSynchronizer(commit, state)
    } else {
      fetchStart(commit)

      return this.$http.$get('https://api.selectel.ru/prices/mks?currency=rub', options)
        .then(res => toCamelCase(res))
        .then(prices => assignPrices(prices, clonePrices, ['group', 'resource']))
        .then(prices => checkPricesWarnings(prices))
        .then(prices => switchMbToGb(prices))
        .then(prices => {
          commit('setMksPrices', prices)

          commit('setMksFetchDate', getFetchDate())

          fetchSuccessful(commit)

          return prices
        })
        .catch(err => fetchErrorsHandler(commit, err))
    }
  }
}

export const getters = {
  getMksFetchDate(state) {
    return state.mksFetchDate
  },
  getMksPrices(state) {
    return state.pricesMks
  },
  getMksFilteredPrices(state) {
    return filterByValues(
      state.pricesMks,
      [
        {
          key: 'resource',
          values: [
            kubernetes.Resource.MKS_CLUSTER_REGIONAL,
            kubernetes.Resource.MKS_CLUSTER_ZONAL
          ]
        },
        {
          key: 'group',
          values: [kubernetes.Group.RU_8]
        }
      ]
    )
  }
}